import React from "react";
import { Dropdown } from "rsuite";
import { IUserSession } from "types/user.interface";
import { getProfileImage } from "util/profile.util";
import styled from "styled-components";
import useAppNavigation from "hooks/useAppNavigation";
import classes from "./NavBarProfileDropdown.module.scss";
import settingsIcon from "../../../assets/images/navbar/settings_icon.png";
import signOutIcon from "../../../assets/images/navbar/signOut_icon.png";

interface IProps {
  user: IUserSession;
}

export interface IDropdownMenuItem {
  label: string;
  icon: string;
  iconAlt: string;
  action: () => void;
}

const Info = styled.div`
  margin-right: 10px;
  margin-left: 10px;

  p {
    text-align: center;
    text-transform: capitalize;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .type {
    margin: 0;
    font-size: 16px;
    text-align: right;
    text-transform: capitalize;
    // color: var(--color-blue);
  }
`;

const ProfileThumbnail = styled.div`
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 4px;

  img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
  }
`;
/**
 * Renders the profile widget in the navbar
 * @param param0
 * @returns
 */
function NavBarProfileDropdown(props: IProps) {
  const { user } = props;

  // get nav menu urls
  const { navToProfile, handleSignOut, navToProfileSettings } =
    useAppNavigation();

  const goToProfile = () => {
    navToProfile(user._id);
  };

  // Dropdown menu items
  const navigationLinks: IDropdownMenuItem[] = [
    {
      label: "Settings",
      action: () => navToProfileSettings(),
      icon: settingsIcon,
      iconAlt: "settings icon",
    },

    {
      label: "Sign Out",
      action: () => handleSignOut(),
      icon: signOutIcon,
      iconAlt: "sign out icon",
    },
  ];

  return (
    <div className={classes.profileContainer} id="profile">
      {user ? (
        <Dropdown
          trigger="hover"
          className={classes.dropdown}
          placement="bottomEnd"
          onClick={goToProfile}
          renderToggle={(prop: any, ref: any) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <div {...prop} ref={ref} className={classes.profile}>
              <ProfileThumbnail>
                <img
                  src={getProfileImage(user.profileImg, user.gender)}
                  alt="User profile"
                />
              </ProfileThumbnail>
            </div>
          )}
        >
          <Dropdown.Item
            className={classes.dropdownFirstCard}
            onSelect={goToProfile}
          >
            <div className={classes.profile}>
              <div className={classes.dropdownThumbnail}>
                <img
                  style={{ width: "100%" }}
                  src={getProfileImage(user.profileImg, user.gender)}
                  alt="User profile"
                />
              </div>
            </div>
            <Info>
              <p>{`${user.username}`}</p>
            </Info>
          </Dropdown.Item>
          {navigationLinks.map((dLink: IDropdownMenuItem) => (
            <Dropdown.Item
              key={dLink.label}
              className={classes.dropdownLink}
              onSelect={dLink.action}
            >
              <img
                style={{ height: "16px", marginRight: "10px" }}
                src={dLink.icon}
                alt={dLink.iconAlt}
              />

              {dLink.label}
            </Dropdown.Item>
          ))}
          {/* <Dropdown.Item>
            <ToggleContainer>
              <Toggle
                checked={theme === "light"}
                aria-label="Switch"
                onChange={switchTheme}
                checkedChildren="light"
                unCheckedChildren="dark"
              />
            </ToggleContainer>
          </Dropdown.Item> */}
        </Dropdown>
      ) : null}
    </div>
  );
}

export default NavBarProfileDropdown;
